import React, { Component } from 'react';
import {
	Card,
	Row,
	Col,
	FormControl,
	FormGroup,
	FormLabel,
	ButtonGroup,
	Button,
} from 'react-bootstrap';
import { toast } from 'react-toastify';
import {
	Accordion as PrimeAccordion,
	AccordionTab,
} from 'primereact/accordion';
import _ from 'lodash';
import ptBR from 'date-fns/locale/pt-BR';
import DatePicker, { registerLocale } from 'react-datepicker';
import Spinner from '@atlaskit/spinner';

import { getMessageFromRequest } from '../../utils/errors';
import Popout from '../../components/Popout';
import Search from '../../components/Search';
import LoadingButton from '../../components/LoadingButton';
import api from '../../api';
import { withUser } from '../../modules/User';
import Grid from '../../components/Grid';

import walletColumnsDef from './walletColumnsDef';
import './styles.scss';

/*
  <Wallet
    acompCarteira={acompCarteira}
  />
*/

registerLocale('ptBR', ptBR);

const defaultButtonStyle = {
	width: '100%',
};

const cityToOptions = ({ code, name, stateCode }) => ({
	label: `${code} - ${name} - ${stateCode}`,
	value: code,
});

const customerToOptions = ({ register, name }) => ({
	label: `${register} - ${name}`,
	value: register,
});

const getValueFromOption = ({ value }) => value;

const getFirstDay = (date) => {
	var newDate = new Date(date);
	var firstDay = new Date(newDate.getFullYear(), newDate.getMonth(), 1);
	return firstDay;
};

const getLastDay = (date) => {
	var newDate = new Date(date);
	var lastDay = new Date(newDate.getFullYear(), newDate.getMonth() + 1, 0);
	return lastDay;
};

const INITIAL_STATE = {
	// wallet
	acompCarteira: [],
	shadowWallet: null,

	// Filters
	// representante: '', // removido para não limpar representante ao rodar handleCLear
	searchedRepresentante: '',
	searchedCidade: [],
	searchedCliente: [],
	searchedSupervisor: [],
	// suggestionPriority: '',
	route: '',
	bought: false,
	requestDate: getFirstDay(Date.now()),
	requestDateFinal: getLastDay(Date.now()),

	// Page State
	isLoading: false,
	isSending: false,
	currentIndex: 0,
	activeIndex: 0,
};

class Wallet extends Component {
	state = {
		...INITIAL_STATE,
		representante: this.props.userProps
			? this.props.userProps.representativeId
			: '',
	};

	// Lifecycle
	componentDidUpdate() {
		// Quando já está logado, ao entrar na pg a request de usuário ainda não vai ter retornado o ID do representante
		// Então, é necessário rodar um spinner (está lá no render) até que tenha um objeto de user
		// Quando entrar o objeto de user, o componentDidUpdate dispara e verifica se chego
		// Caso sim, verifica se existe repId ou se é igual a 0 E, se o representante no estado está vazio e é diferente de 0 (isso é importante para evitar loop de renderização)
		// E então, seta o representante no estado
		if (this.props.userProps) {
			const { representativeId } = this.props.userProps;
			if (
				(representativeId || representativeId === 0) &&
				!this.state.representante &&
				this.state.representante !== 0
			) {
				this.setState({ representante: representativeId });
			}
		}
	}

	// Handlers

	handleActiveIndex = (activeIndex) => this.setState({ activeIndex });

	/*
	 * Uma função para mudança de estado para todos
	 * os campos "Input" da tela, para melhorar a
	 * visualização do código.
	 */
	handleFieldChange = (e) => this.setState({ [e.target.name]: e.target.value });

	/*
	 * Uma função para mudança de estado para todos
	 * os campos "Date" da tela, para melhorar a
	 * visualização do código.
	 */
	handleDateChange = (name, value) => this.setState({ [name]: value });

	handleRequestDate = (requestDate) =>
		this.setState({ requestDate: getFirstDay(requestDate) });

	handleRequestDateFinal = (requestDateFinal) =>
		this.setState({ requestDateFinal: getLastDay(requestDateFinal) });

	handleSearchedCidade = (searchedCidade) => this.setState({ searchedCidade });

	handleSearchedCliente = (searchedCliente) =>
		this.setState({ searchedCliente });

	handleSearchedSupervisor = (searchedSupervisor) =>
		this.setState({ searchedSupervisor });

	handleArticle = (articlesSelected) => this.setState({ articlesSelected });

	handleClear = () =>
		this.setState({
			...INITIAL_STATE,
			tabAtual: this.state.tabAtual,
			articlesOptions: this.state.articlesOptions,
			articlesSelected: this.state.articlesOptions,
		});

	// Request

	handleGetWalletInfo = async () => {
		//getWalletInfo
		const {
			representante,
			searchedSupervisor,
			searchedCidade,
			searchedCliente,
			searchedRepresentante,
		} = this.state;
		this.setState({ isLoading: true, acompCarteira: [] });

		const paramSearchedSupervisor = {
			...(searchedSupervisor.length > 0
				? { supervisors: searchedSupervisor.map(getValueFromOption).toString() }
				: {}),
		};
		const paramSearchedCidade = {
			...(searchedCidade.length > 0
				? { cities: searchedCidade.map(getValueFromOption).toString() }
				: {}),
		};
		const paramSearchedCliente = {
			...(searchedCliente.length > 0
				? { customers: searchedCliente.map(getValueFromOption).toString() }
				: {}),
		};

		try {
			const { data: acompCarteira } = await api.comercial.wallet.getWalletInfo(
				representante === 0 ? searchedRepresentante : representante,
				{
					params: {
						...paramSearchedSupervisor,
						...paramSearchedCidade,
						...paramSearchedCliente,
					},
				},
			);
			this.setState({ acompCarteira });
		} catch (err) {
			toast.error(`Erro ao consultar Carteira: ${err.message}`);
		} finally {
			this.setState({ isLoading: false, activeIndex: null });
		}
	};

	// Loads

	loadCities = _.debounce(
		(inputValue, callback) => {
			api.comercial.filters.city
				.search(inputValue)
				.then(({ data: searchOptions }) => {
					const result = searchOptions.map(cityToOptions);
					callback(result);
				})
				.catch((err) => {
					const message = getMessageFromRequest(err);
					toast.error(message);
				});
		},
		700,
		{ trailing: true, leading: false },
	);

	loadCustomers = _.debounce(
		(inputValue, callback) => {
			api.comercial.filters.customer
				.search(inputValue)
				.then(({ data: searchOptions }) => {
					const result = searchOptions.map(customerToOptions);
					callback(result);
				})
				.catch((err) => {
					const message = getMessageFromRequest(err);
					toast.error(message);
				});
		},
		700,
		{ trailing: true, leading: false },
	);

	render() {
		const {
			// Wallet
			acompCarteira,

			// Filters
			representante,
			searchedRepresentante,
			searchedCidade,
			searchedCliente,
			// searchedSupervisor,
			// suggestionPriority,
			requestDate,
			requestDateFinal,

			// Page State
			isLoading,
			// isSending,
			activeIndex,
		} = this.state;

		if (representante === '')
			return (
				<div
					style={{
						display: 'flex',
						width: '100%',
						height: '100%',
						alignItems: 'center',
						justifyContent: 'center',
					}}
				>
					<Spinner size="xlarge" />
				</div>
			);

		return (
			<>
				<div className="acompVendas-container">
					<PrimeAccordion
						activeIndex={activeIndex}
						onTabChange={(e) => this.handleActiveIndex(e.index)}
						style={{ marginBottom: '0.8vh' }}
					>
						<AccordionTab header="Filtros">
							<Row>
								{representante === 0 && (
									<Col md={3}>
										<FormGroup>
											<FormLabel>Representante</FormLabel>
											<FormControl
												style={{ marginBottom: '20px' }}
												className="rounded-input"
												type="text"
												name="searchedRepresentante"
												value={searchedRepresentante}
												onChange={this.handleFieldChange}
												disabled={representante !== 0}
											/>
										</FormGroup>
									</Col>
								)}
								{
									<Col md={3}>
										<FormGroup>
											<FormLabel>Cidade</FormLabel>
											<Popout
												buttonStyle={defaultButtonStyle}
												title="Selecione um(a)"
												isMulti
												loadOptions={this.loadCities}
												onChange={this.handleSearchedCidade}
												value={searchedCidade}
												Component={Search}
												maxDisplay={1}
												disabled={!representante}
												menuWidth={'100%'}
											/>
										</FormGroup>
									</Col>
								}
								{
									<Col md={3}>
										<FormGroup>
											<FormLabel>Cliente</FormLabel>
											<Popout
												buttonStyle={defaultButtonStyle}
												title="Selecione um(a)"
												isMulti
												loadOptions={this.loadCustomers}
												onChange={this.handleSearchedCliente}
												value={searchedCliente}
												Component={Search}
												maxDisplay={1}
												disabled={!representante}
												menuWidth={'100%'}
											/>
										</FormGroup>
									</Col>
								}
								{
									<Col md={3}>
										<FormGroup>
											<FormLabel>Emissão</FormLabel>
											<div className="date-filter d-flex justify-content-between">
												<DatePicker
													className="form-control rounded-input"
													selected={requestDate}
													selectsStart
													locale="ptBR"
													startDate={requestDate}
													onChange={this.handleRequestDate}
													dateFormat="MM/yyyy"
													showMonthYearPicker
													disabled
												/>
												<i className="fa fa-arrow-right fa-md mt-2" />
												<DatePicker
													className="form-control rounded-input"
													selected={requestDateFinal}
													selectsStart
													locale="ptBR"
													startDate={requestDateFinal}
													onChange={this.handleRequestDateFinal}
													dateFormat="MM/yyyy"
													showMonthYearPicker
													disabled
												/>
											</div>
										</FormGroup>
									</Col>
								}
								<Col md={3}>
									<div className="actions">
										<FormGroup style={{ marginTop: '29px' }}>
											<ButtonGroup>
												{
													<LoadingButton
														type="button"
														variant="success"
														title="Consultar"
														onClick={this.handleGetWalletInfo}
														isLoading={isLoading}
														disabled={!representante && !searchedRepresentante}
													>
														{Button}
													</LoadingButton>
												}
												{
													<Button
														className="btn btn-secondary"
														onClick={this.handleClear}
													>
														Limpar
													</Button>
												}
											</ButtonGroup>
										</FormGroup>
									</div>
								</Col>
							</Row>
						</AccordionTab>
					</PrimeAccordion>
				</div>
				<Card className="card-indicadores">
					<Card.Body className="align-items-center">
						<div className="wallet-styles">
							<Grid
								reflectShadowRows={(shadowWallet) =>
									this.setState({ shadowWallet })
								}
								data={acompCarteira}
								minHeight={400}
								rawColumnsDef={walletColumnsDef}
								rowHeight={20}
								headerRowHeight={20}
								enableSummary
								highlightActiveRow
							/>
						</div>
					</Card.Body>
				</Card>
			</>
		);
	}
}

export default withUser(Wallet);
